import * as React from 'react'

interface IUseGetGlobalSearchResultsPresenterResult {
  query: string
  showEnterHint: boolean
  inputRef: React.RefObject<HTMLInputElement>
  onQueryChange: (value: string) => void
  onSubmit: () => void
}

export const useGetGlobalSearchResultsPresenter =
  (): IUseGetGlobalSearchResultsPresenterResult => {
    const [query, setQuery] = React.useState('')
    const [submittedQuery, setSubmittedQuery] = React.useState('')
    const inputRef = React.useRef<HTMLInputElement>(null)

    const showEnterHint = query !== submittedQuery && query.length > 0

    const onQueryChange = React.useCallback((value: string) => {
      setQuery(value)
      if (value === '') {
        setSubmittedQuery('')
      }
    }, [])

    const onSubmit = React.useCallback(() => {
      setSubmittedQuery((prev) => (prev === query ? prev : query))
    }, [query])

    return {
      query,
      showEnterHint,
      inputRef,
      onQueryChange,
      onSubmit,
    }
  }
